import { Injectable } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private formBuilder: FormBuilder) { }

  searchForm(): FormGroup {
    return this.formBuilder.group({
      make: ['', Validators.required],
      model: ['', Validators.required],
      year: ['', [Validators.required]],
      modification: ['', [Validators.required]],
    });
  }

  sizeSearchForm(): FormGroup {
    return this.formBuilder.group( {
      front_rim_diameter: ['', Validators.required],
      front_rim_width: ['', Validators.required],
      front_bolt_pattern: ['', Validators.required],
      // front_min_offset: ['', Validators.required],
      // front_max_offset: ['', Validators.required],
      rear_rim_diameter: '',
      rear_rim_width: '',
      // rear_bolt_pattern: '',
      search_by_size: true,
      min_offset: ['', Validators.required],
      max_offset: ['', Validators.required],
      rear_min_offset: '',
      rear_max_offset: '',
    });
  }

  // sizeSearchForm(): FormGroup {
  //   return this.formBuilder.group( {
  //     front_rim_diameter: ['', Validators.required],
  //     front_rim_width: ['', Validators.required],
  //     front_bolt_pattern: ['', Validators.required],
  //     // front_min_offset: ['', Validators.required],
  //     // front_max_offset: ['', Validators.required],
  //     rear_rim_diameter: '',
  //     rear_rim_width: '',
  //     // rear_bolt_pattern: '',
  //     // rear_min_offset: '',
  //     // rear_max_offset: '',
  //     search_by_size: true
  //   });
  // }

  orderForm(): FormGroup {
    return this.formBuilder.group({
      id: null,
      billing: this.formBuilder.group({
          first_name: ['', [Validators.required, Validators.maxLength(150)]],
          // last_name: ['', [Validators.required, Validators.maxLength(25)]],
          country: ['', [Validators.required, Validators.maxLength(50)]],
          address: ['', [Validators.required, Validators.maxLength(100)]],
          phone: ['', [Validators.required, Validators.maxLength(20)]],
          email: ['', [Validators.required, Validators.email]],
          order_id: null,
          city: ['', [Validators.required, Validators.maxLength(50)]],
          state: ['', [Validators.required, Validators.maxLength(20)]],
          zip: ['', [Validators.required, Validators.maxLength(20)]],
      }),
      shipping: this.formBuilder.group({
        first_name: [''],
        // last_name: [''],
        country: ['United States'],
        address: [''],
        phone: [''],
        email: [''],
        order_id: null,
        city: [''],
        state: [''],
        zip: [''],
      }),
      payment_method: ['', [Validators.required, Validators.maxLength(50)]],
      delivery_options: ['', [Validators.required, Validators.maxLength(50)]],
      // vehicle_make: ['', [Validators.required, Validators.maxLength(50)]],
      // vehicle_year: ['', [Validators.required, Validators.maxLength(4)]],
      // vehicle_model: ['', [Validators.required, Validators.maxLength(50)]],
      session_id: [''],
      order_notes: null,
      purchase_order_no: null,
      is_same_shipping: true,
      // payment_method: 'Stripe',
      payment_installment: '1',
      store_address: false,
    });
  }

  productReviewForm(): FormGroup {
    return this.formBuilder.group({
      product_id: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.maxLength(100)]],
      reviews: ['', [Validators.required, Validators.maxLength(1000)]]
    });
  }

  profileForm(): FormGroup {
    return this.formBuilder.group({
      // first_name: ['', [Validators.required, Validators.maxLength(100)]],
      // last_name: ['', [Validators.required, Validators.maxLength(100)]],
      address: ['', [Validators.required, Validators.maxLength(150)]],
      // phone: ['', [Validators.required, Validators.maxLength(20)]],
      // city: ['', [Validators.required, Validators.maxLength(20)]],
      state: ['', [Validators.required, Validators.maxLength(20)]],
      lat: [null, Validators.required],
      lng: [null, Validators.required],
      
      business_name:['',[Validators.required, Validators.maxLength(105)]],
      country:['',[Validators.required, Validators.maxLength(80)]],
      license_no:['',[Validators.required, Validators.maxLength(15)]],
      expiry:['',[Validators.required, Validators.maxLength(10)]],
      website:['',[Validators.maxLength(200)]],
      instagram:['',[Validators.maxLength(200)]],


    });
  }

  changePassword(): FormGroup {
    return this.formBuilder.group({
      current: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  addressBookForm(): FormGroup {
    return this.formBuilder.group({
      nickname: ['', [Validators.required, Validators.maxLength(100)]],
      // first_name: ['', [Validators.required, Validators.maxLength(100)]],
      // last_name: ['', [Validators.required, Validators.maxLength(100)]],
      address: ['', [Validators.required, Validators.maxLength(150)]],
      country: ['', [Validators.required, Validators.maxLength(50)]],
      phone_no: ['', [Validators.required, Validators.maxLength(20)]],
      city: ['', [Validators.required, Validators.maxLength(50)]],
      state: ['', [Validators.required, Validators.maxLength(20)]],
      zip: ['', [Validators.required, Validators.maxLength(20)]],
      // email: ['', [Validators.required, Validators.email]],
    });
  }
}
